"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_PREFIX = exports.host = void 0;
exports.host = {
    live: 'https://patronus.idata.shopeemobile.com',
    liveish: 'https://patronus.idata.shopeemobile.com',
    test: 'https://patronus.test.idata.shopeemobile.com',
    staging: 'https://patronus.test.idata.shopeemobile.com',
    uat: 'https://patronus.test.idata.shopeemobile.com',
    mock: 'https://api.seller.shopee.io/mock/1900',
};
exports.API_PREFIX = '/multi-app/web-receiver/api/v1/receiver/web';
